import { useMutation } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { login } from '@/lib/auth/api'
import type { LoginInput, VenueManagerLoginResult } from '@/lib/auth/types'

/**
 * 로그인 뮤테이션.
 *
 * 토큰 저장까지 `lib/auth/api.ts#login` 이 끝낸다(설계 불변식 1·3) — 훅은 호출과
 * 상태 노출만 담당하고 저장 위치를 알지 않는다.
 *
 * 에러 타입이 `ApiError` 라 화면이 `error.reason` 으로 실패 사유를 분기할 수 있다(설계 §2-1(c)).
 */
export function useLogin() {
  return useMutation<VenueManagerLoginResult, ApiError, LoginInput>({ mutationFn: login })
}
